export const visaTypeOptions = [
  { value: "student", label: "Student" },
  { value: "tourist", label: "Tourist/Visitor" },
  { value: "work", label: "Work" },
  { value: "other", label: "Other" },
];

export const applicationTypeOptions = [
  { value: "onshore", label: "Onshore" },
  { value: "offshore", label: "Offshore" },
];

export const oshcTypeOptions = [
  { value: "single ", label: "Single " },
  { value: "couple", label: "Couple" },
  { value: "family", label: "Family" },
];

export const disabilityOptions = [
  { value: "hearing", label: "Hard of Hearing/Deaf" },
  { value: "physical", label: "Physical Disability" },
  { value: "intellectual", label: "Intellectual Disability" },
  { value: "learning", label: "Specific Learning Disability" },
  { value: "mental_health", label: "Mental Health Condition" },
  { value: "brain_injury", label: "Acquired Brain Injury" },
  { value: "vision", label: "Low Vision/Blind" },
  { value: "medical", label: "Medical Condition" },
  { value: "neurological", label: "Neurological Condition" },
];

// ?Put in dynamoDB
export const declarationOptions = [
  {
    value: "informationAccuracy",
    label:
      "I declare that the information provided in this Application Form is true, correct, and complete, and that all academic records and supporting documentation provided are authentic and accurate representations of my academic achievements.",
  },
  {
    value: "courseUnderstanding",
    label:
      "I confirm that I have read, understood, and accept the requirements of the course as outlined on the institution's website and in related documentation.",
  },
  {
    value: "informationAccessAuthorization",
    label:
      "I authorize Edubay and my chosen institution(s) to obtain enrollment, academic, and verification information from any of my previous or current education providers, employers, or relevant organizations.",
  },
  {
    value: "costAwareness",
    label:
      "I declare that I have accessed and reviewed information regarding all costs related to studying at my chosen institution(s), including tuition fees, ancillary costs, and living expenses for myself and any dependents accompanying me.",
  },
  {
    value: "financialCapability",
    label:
      "I declare that I have adequate funds available to cover all tuition fees, ancillary costs, living expenses, and other related costs for myself and any dependents traveling with me throughout the duration of my studies.",
  },
  {
    value: "privacyAndInformationSharing",
    label: `I consent to:<ul><li>Information collected about me being disclosed if authorized or required by law, government agencies, or designated authorities;</li><li>My application data being shared between Edubay, my chosen institution(s), and any assigned agents for processing purposes;</li><li>Edubay storing and processing my application data in accordance with its Privacy Policy;</li><li>Information sharing necessary for application processing, enrolment, and ongoing student services.</li></ul>`,
  },
  {
    value: "ageDeclaration",
    label:
      "I declare that I will be over 18 years of age (or meet the minimum age requirement) by the date my enrolment status is confirmed.",
  },
  {
    value: "consequencesUnderstanding",
    label:
      "I understand that providing false, incomplete, or fraudulent information may lead to the refusal of my application, cancellation of enrolment, or other appropriate action by the institution.",
  },
  {
    value: "agentAndThirdPartyProcessing",
    label: `I understand that:<ul><li>If I apply through an approved agent, or if the institution assigns an agent to my application, all correspondence may be shared with that agent;</li><li>My application will be processed through Edubay and shared with my chosen institution(s);</li><li>Edubay, institution, and any assigned agents may communicate regarding my application as necessary for processing.</li><ul>`,
  },
  {
    value: "verificationAuthorization",
    label:
      "I authorize Edubay, institution, and any assigned agents to verify the information I have provided with other institutions, government departments, regulatory bodies, and other relevant organizations.",
  },
  {
    value: "changeNotification",
    label:
      "I commit to process any changes to the information I have provided in this application through Edubay immediately, including personal details, contact information, or circumstances affecting my eligibility. I understand that all changes must be made through Edubay, which will notify my chosen institution(s) accordingly.",
  },
  {
    value: "visaAndLegalCompliance",
    label:
      "I understand and agree to comply with all visa conditions, government regulations, and legal requirements applicable to my study in the destination country, including but not limited to relevant education acts, national codes, and immigration requirements specific to my chosen institution(s) and study location(s).",
  },
  {
    value: "policyAcceptance",
    label:
      "I acknowledge that I have read, understood, and agree to be bound by all institutional policies and procedures, including but not limited to refund policies, deferral procedures, academic policies, and student conduct requirements.",
  },
  {
    value: "contactDetailsResponsibility",
    label:
      "I agree to provide accurate contact details and residential address information, and to process any changes to these details through Edubay during application processing and while enrolled. I understand that Edubay will coordinate updates with my chosen institution(s).",
  },
  {
    value: "documentationAndRecordRetention",
    label: `I understand that: <ul>
      <li>Edubay will store and maintain copies of my submitted documentation and application records for processing and compliance purposes;</li><li>My chosen institution(s) will have access to my documentation as necessary for application processing and enrollment;</li><li>I will have ongoing access to my application records and signed documents through Edubay;</li><li>Additional documentation may be requested through Edubay as required for verification or compliance purposes;</li><li>Document retention periods will be governed by applicable legal and regulatory requirements.</li></ul>`,
  },
  {
    value: "thirdPartyDisclosureLimitations",
    label: `I acknowledge that:<ul><li>Due to privacy regulations, my information cannot be disclosed to unauthorized third parties (such as parents, relatives, or friends) without my written consent;</li><li>This does not apply to authorized parties involved in my application processing (Edubay, institution, assigned agents, government agencies, or regulatory bodies);</li><li>I may be required to provide separate consent for any disclosures beyond those necessary for application processing and enrolment.</li><ul>`,
  },
  {
    value: "finalConfirmationAndDigitalSignature",
    label:
      "By ticking this box and submitting my application, I confirm that I have read, understood, and agree to all declarations above. I understand that this digital submission constitutes my legal signature and creates a binding agreement equivalent to a handwritten signature under applicable electronic signature laws.",
  },
];

export const marketingOption = [
  {
    value: "marketingConsent",
    label:
      "I consent to the use of my testimonials, photographs, audio/video recordings, and academic achievements for marketing and promotional purposes.",
  },
];

export enum OfferCondition {
  ALL = "ALL",
  ACADEMIC = "ACADEMIC",
  ENGLISH_LANGUAGE = "ENGLISH_LANGUAGE",
  GENUINE_STUDENT = "GENUINE_STUDENT",
  OSHC = "OSHC",
}

export const offerConditions = [
  { value: OfferCondition.ALL, label: "All" },
  { value: OfferCondition.ACADEMIC, label: "Academic Verification" },
  {
    value: OfferCondition.ENGLISH_LANGUAGE,
    label: "English Language Verification",
  },
  {
    value: OfferCondition.GENUINE_STUDENT,
    label: "Genuine Student Assessment",
  },
  { value: OfferCondition.OSHC, label: "Overseas Student Health Cover" },
];
